var _style, _ellipse, _path, _path2, _path3, _path4, _path5, _circle, _path6, _polygon, _circle2, _path7, _path8, _circle3, _path9, _circle4, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle5, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793 551.7",
    style: {
      enableBackground: "new 0 0 793 551.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#E6E6E6;}\r\n\t.st1{fill:#2F2E41;}\r\n\t.st2{fill:#3F3D56;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#6C63FF;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:#FFB8B8;}\r\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 158,
    cy: 539.7,
    rx: 158,
    ry: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.8,122.4c27.5-11.7,61.7-4.3,95.2,0.9c0.3-6.2,4.1-13.8,0.1-18.2c-4.8-5.3-4.4-10.8-1.5-16.4 c7.4-14.3-3.2-29.4-13.9-42.1c-4.9-5.8-12.2-8.8-19.8-8.3l-19.8,1.4c-9.9,0.7-18.3,7.5-21.1,16.9l0,0c-4.7,6.4-7.3,12.8-5.7,19.2 c-7.1,4.8-8.3,10.7-5.1,17.3c2.7,4.1,2.7,8.2-0.1,12.1c-3.7,5-6.5,10.6-8.3,16.5L120.8,122.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M774.2,477H213.8c-10.4,0-18.8-8.4-18.8-18.8l0,0l0,0c203.2-23.6,402.5-23.6,598,0l0,0 C793,468.5,784.6,477,774.2,477L774.2,477z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M793,459.3l-598-1.1l69.3-116.6l0.3-0.6V84c0-13.1,10.6-23.8,23.8-23.8c0,0,0,0,0,0h407.9 c13.1,0,23.8,10.6,23.8,23.8c0,0,0,0,0,0v258.8L793,459.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.9,76.8c-4.3,0-7.7,3.5-7.7,7.7v234.3c0,4.3,3.5,7.7,7.7,7.7h412.3c4.3,0,7.7-3.5,7.7-7.7V84.6 c0-4.3-3.5-7.7-7.7-7.7L287.9,76.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.6,357.6c-1.3,0-2.5,0.8-3,1.9l-21.4,46.4c-0.8,1.7,0,3.6,1.6,4.4c0.4,0.2,0.9,0.3,1.4,0.3h449.1 c1.8,0,3.3-1.5,3.3-3.3c0-0.5-0.1-1-0.4-1.5l-23.2-46.4c-0.6-1.1-1.7-1.8-3-1.8L289.6,357.6z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 492.3,
    cy: 68,
    r: 5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M448.2,419.5c-1.5,0-2.8,1-3.2,2.5l-5.4,19.9c-0.5,1.8,0.6,3.6,2.3,4.1c0.3,0.1,0.6,0.1,0.9,0.1h101.9 c1.8,0,3.3-1.5,3.3-3.3c0-0.4-0.1-0.7-0.2-1.1l-6.9-19.9c-0.5-1.3-1.7-2.2-3.1-2.2L448.2,419.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "720,337.1 720,341.6 264.3,341.6 264.6,341 264.6,337.1 "
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 707.3,
    cy: 77.4,
    r: 77.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M739.4,111.1h-64.1c-2.4,0-4.4-2-4.4-4.4V68c0-2.4,2-4.4,4.4-4.4h64.1c2.4,0,4.4,2,4.4,4.4v38.7 C743.8,109.1,741.8,111.1,739.4,111.1z M675.3,68v38.7h64.1l0-38.7L675.3,68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M727.2,68h-39.8V50.3c0-12.8,8.4-22.1,19.9-22.1s19.9,9.3,19.9,22.1V68z M691.9,63.6h31V50.3 c0-10.4-6.4-17.7-15.5-17.7s-15.5,7.3-15.5,17.7L691.9,63.6z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 707.3,
    cy: 86.2,
    r: 4.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.3,247.1H334.7c-3.3,0-5.9-2.6-5.9-5.9v-79c0-3.3,2.6-5.9,5.9-5.9h318.6c3.3,0,5.9,2.6,5.9,5.9v79 C659.2,244.5,656.6,247.1,653.3,247.1z M334.7,158.7c-2,0-3.5,1.6-3.5,3.5v79c0,2,1.6,3.5,3.5,3.5h318.6c2,0,3.5-1.6,3.5-3.5v-79 c0-2-1.6-3.5-3.5-3.5L334.7,158.7z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 384.2,
    cy: 198.7,
    r: 24
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.7,182.7c-2.2,0-4,1.8-4,4c0,2.2,1.8,4,4,4c0,0,0,0,0,0h188.9c2.2,0,4-1.8,4-4s-1.8-4-4-4H439.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.7,206.7c-2.2,0-4,1.8-4,4s1.8,4,4,4H521c2.2,0,4-1.8,4-4s-1.8-4-4-4H439.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M263.5,208.3l-58.9,31.3l-0.7-26.1c19.2-3.2,37.5-8.8,54.4-17.9l6.2-15.2c2.1-5.3,8.2-7.8,13.4-5.7 c1.6,0.6,3,1.7,4.1,3l0,0c3.4,4.2,3.1,10.3-0.9,14.1L263.5,208.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,389.1L119.6,389.1c-0.9-3.2-0.3-6.6,1.5-9.4l12.9-19.9c6.3-9.7,19-13.1,29.3-7.7l0,0 c-5.4,9.3-4.7,17.4,1.9,24.4c-10.2,5-19.6,11.4-27.9,19c-5.3,3.6-12.5,2.2-16.1-3C120.5,391.5,119.9,390.4,119.6,389.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.2,363.2L266.2,363.2c-4,6.6-11.1,10.7-18.9,10.8l-86,0.7l-3.7-21.6l38-11.2l-32.1-24.6l35-41l63.6,59.3 C270,342.6,271.6,354.2,266.2,363.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148,511h-20.1c-18.1-123.9-36.5-248.1,17.9-294.5l64.1,10.4l-8.2,54.4l-35.8,41L148,511z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.6,539.1L165.6,539.1c-3.2,0.9-6.6,0.3-9.4-1.5l-21.9-2.9c-9.7-6.3-13.1-19-7.7-29.3l0,0 c9.3,5.4,17.4,4.7,24.4-1.9c5,10.1,13.2,9.5,21,17.9c3.6,5.3,2.2,12.5-3,16.1C168.1,538.2,166.9,538.8,165.6,539.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M195.7,133.8l-37.3-8.9c6.2-12.7,6.7-26.8,3.7-41.8l25.4-0.7C188.3,100.9,190.7,118.3,195.7,133.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.9,249.4c-27.1,18.5-46.3,0.6-60.9-26.9c2-16.9-1.3-37-7.4-59c-5.6-20,5-41.1,24.5-48.4l0,0l32.1,13.4 c27.2,22.2,32.6,46.2,22.4,71.6L205.9,249.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.8,152.4L98,168.1l52.9,31.3l7.4,18.2c2,4.9-0.4,10.6-5.3,12.6c-0.2,0.1-0.3,0.1-0.5,0.2l0,0 c-5,1.7-10.5-0.9-12.3-6c-0.3-0.8-0.5-1.7-0.5-2.6l-0.7-12.7l-67.3-22.2c-4.6-1.5-8.2-5.1-9.9-9.6l0,0c-2.4-6.7,0-14.3,5.9-18.3 l54.1-37.1L127.8,152.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.6,155.4c-12.4-5.5-23.7,0.5-38,5.2l-2.2-39.5c14.2-7.6,27.7-9.6,40.3-3.7L157.6,155.4z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 172.5,
    cy: 78.1,
    r: 23.8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M201,75.1c-23.6,2.3-41.5-1.5-53-12.5v-8.8h51L201,75.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin01);
export default __webpack_public_path__ + "static/media/login_01.52de7983c6451f058c34e87613bdf2c7.svg";
export { ForwardRef as ReactComponent };